import { Injectable } from '@angular/core';
import { EvkHttpService, EvkUpdateServiceBase, EvkResponseType } from '@evomatik/evk-common';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class EvkDiligenciaUpdateService extends EvkUpdateServiceBase<any> {

    constructor(h: EvkHttpService) {
        super(h);
    }

    public get api(): string {
        return '/seaged-diligencias-service/diligencia/v2';
    }

    evkOnBeforeEdit(data: any): Observable<any> {
        return undefined;
    }

    evkOnDoneEdit(response: any): void {
    }

    evkOnErrorEdit(error: any): void {
    }


    public putFirmaElctronica(data: any, idDiligencia: string) {
        return this.http.put<EvkResponseType<any>>(`${this.api}/firma-electronica/${idDiligencia}`, data).pipe(
            map(response => response.data)
        );
    }


}
